import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ReplySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ReplySVG;
